<template>
    <div class="btn row-center" @click="change">
        <img :src="iconShow()" class="icon" alt="图标">
        <span class="content" :style="fontStyle()">{{content}}</span>
    </div>
</template>

<script>
    export default {
        name: "MenuButtonColumn",
        props: {
            // 背景
            bg: Array,
            // 图标
            icons: Array,
            // 内容
            content: String,
            // 参数
            params: Object,
            // 是否选中
            selected: Boolean,
        },
        watch: {
            selected(n, o) {
                if (n) {
                    this.$emit("onSelected")
                } else {
                    this.$emit("onUnselected")
                }
            }
        },
        methods: {
            /**
             * 背景切换
             */
            bgStyle() {
                return `backgroundImage:url("${this.selected ? this.bg[1] : this.bg[0]}")`
            },
            /*
                图标切换
             */
            iconShow() {
                return this.selected ? this.icons[1] : this.icons[0]
            },
            fontStyle() {
                return this.selected ? `color:#0D94FF;` : `color:#fff;`
            },
            change() {
                // this.selected = !this.selected
                this.$emit("click")
            }
        }
    }
</script>

<style scoped lang="less">
    .row-center {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;
    }

    .column-center {
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        align-items: center;
    }

    .btn {
        .w(160);
        .h(40);
        background-size: 100% 100%;
        cursor: pointer;
        // background-color: rgba(255,255,255, .8);
        margin-bottom:8px ;
        .icon {
            .w(24);
            .h(24);
        }

        img {
            .wh(19, 0);
            margin-right: @w;
        }

        .content {
            .wh(17, 0);
            font-size: @w;
        }
    }
</style>